var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "component-form" },
    [
      _c("h1", { staticClass: "form-title" }, [_vm._v("Syllabus Draft")]),
      _c("p", { staticClass: "text mt-30" }, [
        _vm._v(
          " A template (below) has been provided for your convenience when formatting your seminar outline. Please create a copy of the document and replace all the highlighted fields with relevant information pertaining to your seminar. When finished, please submit a sharing link (with editing enabled) to the SL Portal. "
        )
      ]),
      _c(
        "Button",
        {
          staticClass: "btn-download mt-20",
          attrs: { skin: "grey" },
          on: { click: _vm.handleClickDownload }
        },
        [_vm._v("Syllabus Template")]
      ),
      _c("p", { staticClass: "text mt-20" }, [
        _vm._v(
          " With the syllabus draft, we’ll need to collect your seminar description and required/optional readings. Please fill out the form below. "
        )
      ]),
      _c(
        "div",
        { staticClass: "inp-wrap mt-20 large" },
        [
          _c("Input", {
            attrs: { label: "Official Seminar Title", value: _vm.value.title },
            on: {
              input: function($event) {
                return _vm.handleInput($event, "title")
              }
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "inp-wrap mt-20 large" },
        [
          _c("Textarea", {
            attrs: {
              counter: false,
              placeholder: "Official Seminar Description",
              value: _vm.value.description
            },
            on: {
              input: function($event) {
                return _vm.handleInput($event, "description")
              }
            }
          })
        ],
        1
      ),
      _vm._m(0),
      _c("CheckboxGroup", {
        staticClass: "mt-10 checkboxgroup-wrap inp-wrap large",
        attrs: { options: _vm.GROUP_OPTIONS, value: _vm.value.track },
        on: {
          input: function($event) {
            return _vm.handleInput($event, "track")
          }
        }
      }),
      _c("p", { staticClass: "text bold mt-30 big" }, [
        _vm._v("Upload merged reading PDF")
      ]),
      _c("FileUploader", {
        staticClass: "mt-20 inp-wrap big",
        attrs: {
          text: "Upload",
          acceptType: ["PDF"],
          value: _vm.value.pdf,
          loadText: "loading",
          role: _vm.ROLES.SL
        },
        on: {
          input: function($event) {
            return _vm.handleInput($event, "pdf")
          }
        }
      }),
      _c("p", { staticClass: "text bold big mt-30" }, [
        _vm._v("Please paste your syllabus sharing link here and click submit")
      ]),
      _c(
        "div",
        { staticClass: "inp-wrap mt-20 large" },
        [
          _c("Textarea", {
            attrs: { counter: false, placeholder: "", value: _vm.value.link },
            on: {
              input: function($event) {
                return _vm.handleInput($event, "link")
              }
            }
          })
        ],
        1
      ),
      _c(
        "Button",
        { staticClass: "btn-submit", on: { click: _vm.handleClickSubmit } },
        [_vm._v("Submit")]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "text bold big mt-30" }, [
      _vm._v("Seminar Track "),
      _c("span", { staticClass: "weak" }, [_vm._v("Choose all that applies")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }